export function setSearchModalActive(open: boolean): void {
  document.body.classList.toggle("modal-active", open);
  if (open) {
    document.body.setAttribute("data-modal", "#search-modal-new");
  } else {
    document.body.removeAttribute("data-modal");
  }
}
